import { useCurrentFrame } from 'remotion';
import { useBuildLogAnimation } from '../hooks/use-build-log-animation';
import IdeShell from '../components/ide-shell';
import CodeEditorVideo from '../components/code-editor-video';
import OutputPanel from '../components/output-panel';
import MenuDropdown from '../components/menu-dropdown';

// Build menu items shown before build starts
const BUILD_MENU_ITEMS = [
  { label: 'Build Solution', shortcut: 'Ctrl+Shift+B', highlight: false },
  { label: 'Rebuild Solution' },
  { separator: true },
  { label: 'Clean Solution' },
];

// Menu position for "Build" in VS 2022 title bar
const BUILD_MENU_X = 232;
const BUILD_MENU_Y = 30;

// Timeline: menu appears → highlight item → menu closes → logs start
const MENU_SHOW_FRAME = 15;
const MENU_HIGHLIGHT_FRAME = 60;
const MENU_CLOSE_FRAME = 100;
const LOGS_START_FRAME = 110;

export default function BuildScene({
  buildLogs = [],
  code = '',
  filename = 'Program.cs',
  projectName = 'HelloWorld',
  breakpoints,
  debugLine,
}) {
  const frame = useCurrentFrame();
  const lineCount = code ? code.split('\n').length : 1;

  // Phase 1: Show Build menu dropdown (frames 15-100)
  const showMenu = frame >= MENU_SHOW_FRAME && frame < MENU_CLOSE_FRAME;
  const menuItems = BUILD_MENU_ITEMS.map(item => ({
    ...item,
    highlight: item.label === 'Build Solution' && frame >= MENU_HIGHLIGHT_FRAME,
  }));

  // Phase 2: Show build logs after menu closes (offset by LOGS_START_FRAME)
  const adjustedLogs = frame >= LOGS_START_FRAME
    ? buildLogs
    : [];
  const visibleLogs = useBuildLogAnimation(adjustedLogs);

  return (
    <IdeShell projectName={projectName} filename={filename} step={3} lineCount={lineCount}
      overlay={showMenu && (
        <MenuDropdown
          items={menuItems}
          x={BUILD_MENU_X}
          y={BUILD_MENU_Y}
        />
      )}
    >
      <CodeEditorVideo
        typedCode={code}
        step={3}
        lineCount={lineCount}
        projectName={projectName}
        filename={filename}
        breakpoints={breakpoints}
        debugLine={debugLine}
      />
      <OutputPanel buildLogs={visibleLogs} />
    </IdeShell>
  );
}
